module.exports = __webpack_public_path__ + "static/media/stereum_step1.4901c6c8.png";